module.exports = {
  locale_name: "Português",
  locale_shorthand: ["pt", "portuguese"],
  // Traduções:
  justifyCenter: "Centralizar",
  justifyLeft: "Justificar à Esquerda",
  justifyRight: "Justificar à Direita",
  bold: "Negrito",
  code: "Código",
  headings: "Cabeçalhos (h1-h6)",
  link: "Hiperlink",
  image: "Inserir Imagem",
  italic: "Itálico",
  orderedList: "Lista Ordenada (1, 2, 3, ...)",
  unorderedList: "Lista Desordenada",
  removeFormat:
    "Remove formatação.\nLimpa cabeçalhos, negrito, itálico, texto sublinhado, etc.",
  separator: null,
  table: "Inserir Tabela",
  underline: "Sublinhado",
};
